import { jsx as _jsx } from "react/jsx-runtime";
import { ClickAwayListener, Fade, Tooltip as MuiTooltip, styled, tooltipClasses, } from '@mui/material';
import { forwardRef, useState } from 'react';
import { Button } from '../../atoms/Button';
export const Tooltip = forwardRef(function Tooltip({ tooltip }, ref) {
    const [open, setOpen] = useState(false);
    const handleTooltipClose = () => {
        setOpen(false);
    };
    const handleTooltipOpen = () => {
        setOpen(true);
    };
    return (_jsx(ClickAwayListener, { onClickAway: handleTooltipClose, children: _jsx("div", { children: _jsx(TooltipStyled, { title: tooltip?.description ? tooltip.description : '', PopperProps: {
                    disablePortal: true,
                }, TransitionComponent: Fade, TransitionProps: { timeout: 600 }, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, onClose: handleTooltipClose, open: open, arrow: true, children: _jsx(Button, { onClick: handleTooltipOpen, variant: "text", icon: "information", ref: ref }) }) }) }));
});
const TooltipStyled = styled(({ className, ...props }) => (_jsx(MuiTooltip, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.secondary.contrastText,
        color: theme.palette.primary.dark,
        padding: theme.spacing(105),
    },
    [`& .${tooltipClasses.tooltipArrow}`]: {
        backgroundColor: theme.palette.secondary.contrastText,
    },
}));
